import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { PrevButton, NextButton } from '../../style/ModalDesignacao.styles';

const PaginationControls = ({
  pontoSelecionado,
  hasPrevPage,
  hasNextPage,
  onPrevPage,
  onNextPage,
}) => {
  if (!pontoSelecionado) {
    return (
      <>
        <div />
        <div />
      </>
    );
  }

  return (
    <>
      {hasPrevPage ? (
        <PrevButton onClick={onPrevPage}>
          <FaChevronRight
            style={{ transform: 'rotate(180deg)', fontSize: 12, marginRight: 1 }}
          />{' '}
          Anterior
        </PrevButton>
      ) : (
        <div />
      )}
      {hasNextPage ? (
        <NextButton onClick={onNextPage}>
          Próxima{' '}
          <FaChevronRight style={{ fontSize: 12, marginLeft: 1 }} />
        </NextButton>
      ) : (
        <div />
      )}
    </>
  );
};

export default PaginationControls;
